import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DatePickerComponent, FormFieldComponent, MODAL_DATA } from '@h5s/design-system';
import { ActionType, ModalComponent, ModalReference } from '@h5s/util-overlay';
import { FEATURE_PS_TRANSLATIONS } from '../../translations/feature-ps.translations';
import { DownloadPsReceiptModalParams } from './models/download-ps-receipt-modal-params';
import { DownloadPsReceiptModalResult } from './models/download-ps-receipt-modal-result';

@Component({
  selector: 'h5s-ps-download-receipt',
  imports: [FormFieldComponent, DatePickerComponent, ReactiveFormsModule],
  templateUrl: './ps-download-receipt.component.html',
  styleUrl: './ps-download-receipt.component.scss',
})
export class PsDownloadReceiptComponent implements ModalComponent {
  private readonly modalRef = inject(ModalReference);
  private readonly modalParams: DownloadPsReceiptModalParams = inject<DownloadPsReceiptModalParams>(MODAL_DATA);
  private readonly fb = inject(FormBuilder);

  public selectedDateFormControl = this.fb.nonNullable.control(this.modalParams.selectedDate, Validators.required);

  public readonly translations = FEATURE_PS_TRANSLATIONS;

  public onClosed(actionType: ActionType): void {
    if (actionType !== ActionType.Confirm) {
      this.modalRef.close();
      return;
    }

    const response = new DownloadPsReceiptModalResult(this.selectedDateFormControl.value);
    this.modalRef.close({
      actionType: ActionType.Confirm,
      data: response,
    });
  }
}
